import { render, staticRenderFns } from "./create-employee.vue?vue&type=template&id=5a61f2ed&scoped=true"
import script from "./create-employee.vue?vue&type=script&lang=js"
export * from "./create-employee.vue?vue&type=script&lang=js"
import style0 from "./create-employee.vue?vue&type=style&index=0&id=5a61f2ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a61f2ed",
  null
  
)

export default component.exports